import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
// import { CheckboxList } from '../SettingsViews/SettingsComponents/CheckboxList'
import { ContextBar } from '@tecuity/granite-ui/ContextBar'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import './ConversionModal.scss'
import RightArrow from '@tecuity/sos-icons/react/right-arrow'
import Revert from '@tecuity/sos-icons/react/revert'
import { Spinner } from '../../Loaders/Loaders'
import * as api from '../../../requests'
import { setErrorToast } from '../../../actions'

const MergerModal = ({
  selectedRow,
  recordTypeOptions,
  recordSubTypeOptions,
  filingTypeOptions,
  // businessStatusTypeOptions = [],
  // getRecordTypeName,
  // getRecordSubTypeName,
  closeModal,
  // receiptItemTypes,
  // appReports = [],
  filingType,
}) => {
  const dispatch = useDispatch()
  const [xref, setXref] = useState({ ...selectedRow })
  // const [reportIds, setReportIds] = useState([])
  // const [receiptItemTypeIds, setReceiptItemTypeIds] = useState([])
  const [initialSubTypeXref, setInitialSubTypeXref] = useState([])
  const [convertedSubTypeXref, setConvertedSubTypeXref] = useState([])
  const [survivorError, setSurvivorError] = useState(false)
  const [nonSurvivorError, setNonSurvivorError] = useState(false)
  const [loadingSurvivorXref, setLoadingSurvivorXref] = useState(false)
  const [loadingNonSurvivorXref, setLoadingNonSurvivorXref] = useState(false)
  // const [loading, setLoading] = useState(false)

  const revert = () => {
    setXref({ ...selectedRow })
    // setReportIds(() => [...selectedRow.ReportIds])
    // setReceiptItemTypeIds(() => [...selectedRow.ReceiptItemTypeIds])
  }

  useEffect(() => {
    revert()
  }, [selectedRow])

  const getRecordSubTypeXref = (recordTypeId, setSubTypeXref, setLoading) => {
    //api call
    setSubTypeXref([])
    setLoading(true)
    api.GET_BUSINESS_RECORD_SUB_TYPE_XREFS_BY_RECORD_TYPE(
      recordTypeId,
      (res) => {
        // console.log(res.BusinessRecordSubTypeIds)
        setSubTypeXref(res.BusinessRecordSubTypeIds)
        setLoading(false)
      },
      (err) => {
        console.error('retrieving', err)
        setLoading(false)
      }
    )
  }

  useEffect(() => {
    const controller = new AbortController()
    if (filingType && xref.SurvivorBusinessRecordTypeId) {
      getBusinessFilingTypeIdsByRecordTypeSubType(
        controller,
        xref.SurvivorBusinessRecordTypeId,
        xref.SurvivorBusinessRecordSubTypeId || null,
        filingType,
        setSurvivorError,
        setLoadingSurvivorXref
      )
    }
    return () => {
      controller.abort()
    }
  }, [filingType, xref.SurvivorBusinessRecordTypeId, xref.SurvivorBusinessRecordSubTypeId])

  useEffect(() => {
    const controller = new AbortController()
    if (xref.NonSurvivorBusinessFilingTypeId && xref.NonSurvivorBusinessRecordTypeId) {
      getBusinessFilingTypeIdsByRecordTypeSubType(
        controller,
        xref.NonSurvivorBusinessRecordTypeId,
        xref.NonSurvivorBusinessRecordSubTypeId || null,
        xref.NonSurvivorBusinessFilingTypeId,
        setNonSurvivorError,
        setLoadingNonSurvivorXref
      )
    }
    return () => {
      controller.abort()
    }
  }, [
    xref.NonSurvivorBusinessFilingTypeId,
    xref.NonSurvivorBusinessRecordTypeId,
    xref.NonSurvivorBusinessRecordSubTypeId,
  ])

  const getBusinessFilingTypeIdsByRecordTypeSubType = (
    controller,
    recordTypeId,
    recordSubTypeId,
    filingTypeId,
    setError,
    setLoading
  ) => {
    // api call
    setError(false)
    setLoading(true)
    api.GET_SETTINGS_BUSINESS_FILING_TO_RECORD_XREF(
      { signal: controller.signal },
      recordTypeId,
      recordSubTypeId,
      filingTypeId,
      (res) => {
        setError(res ? false : true)
        setLoading(false)
      },
      (err) => {
        console.error(err)
        setError(true)
        setLoading(false)
      }
    )
  }

  useEffect(() => {
    getRecordSubTypeXref(
      xref.SurvivorBusinessRecordTypeId,
      setInitialSubTypeXref,
      setLoadingSurvivorXref
    )
  }, [xref.SurvivorBusinessRecordTypeId])

  useEffect(() => {
    getRecordSubTypeXref(
      xref.NonSurvivorBusinessRecordTypeId,
      setConvertedSubTypeXref,
      setLoadingNonSurvivorXref
    )
  }, [xref.NonSurvivorBusinessRecordTypeId])

  const filteredInitialSubTypes = useMemo(() => {
    return [
      { value: '', label: 'None' },
      ...recordSubTypeOptions.filter((opt) => initialSubTypeXref.includes(opt.value)),
    ]
  }, [recordSubTypeOptions, initialSubTypeXref])

  const filteredConvertedSubTypes = useMemo(() => {
    return [
      { value: '', label: 'None' },
      ...recordSubTypeOptions.filter((opt) => convertedSubTypeXref.includes(opt.value)),
    ]
  }, [recordSubTypeOptions, convertedSubTypeXref])

  const saveXref = () => {
    api.SAVE_SETTINGS_BUSINESS_MERGER_TYPE_XREF(
      {
        ...xref,
        BusinessFilingTypeId: Number(filingType),
        SurvivorBusinessRecordSubTypeId: xref.SurvivorBusinessRecordSubTypeId || null,
        NonSurvivorBusinessRecordSubTypeId: xref.NonSurvivorBusinessRecordSubTypeId || null,
        // ReceiptItemTypeIds: receiptItemTypeIds,
        // ReportIds: reportIds,
      },
      xref.MergerConfigurationXrefId === 0 ? 'POST' : 'PUT',
      () => {
        closeModal(true)
      },
      (err) => {
        console.error(err)
        dispatch(setErrorToast('Failed to Save XRef'))
      }
    )
  }

  return (
    <div className="conversion-modal">
      <div className="from-to-row">
        <div className="from-to-column from">
          <SelectBox
            label="Survivor Record Type"
            value={xref.SurvivorBusinessRecordTypeId}
            onChange={(val) => {
              setXref({
                ...xref,
                SurvivorBusinessRecordTypeId: Number(val),
                SurvivorBusinessRecordSubTypeId: '',
              })
            }}
            options={recordTypeOptions}
          />
          <SelectBox
            noPlaceholder
            label="Survivor Record Sub Type"
            value={xref.SurvivorBusinessRecordSubTypeId}
            onChange={(val) => {
              setXref({
                ...xref,
                SurvivorBusinessRecordSubTypeId: Number(val),
              })
            }}
            options={filteredInitialSubTypes}
          />
          <SelectBox
            label="Survivor Filing Type"
            value={filingType}
            options={filingTypeOptions}
            disabled
          />
          {survivorError && !loadingSurvivorXref && (
            <div className="xref-warning">
              Warning: No Business Record to Filing Xref configured for selected Survivor types!
            </div>
          )}
          {loadingSurvivorXref && (
            <div className="conversion-spinner">
              <Spinner size="small" themeColor="dark-neutral" />
            </div>
          )}
        </div>
        <div className="from-to-column to">
          <SelectBox
            label="Non Survivor Record Type"
            value={xref.NonSurvivorBusinessRecordTypeId}
            onChange={(val) => {
              setXref({
                ...xref,
                NonSurvivorBusinessRecordTypeId: Number(val),
                NonSurvivorBusinessRecordSubTypeId: '',
              })
            }}
            options={recordTypeOptions}
          />
          <SelectBox
            noPlaceholder
            label="Non Survivor Record Sub Type"
            value={xref.NonSurvivorBusinessRecordSubTypeId}
            onChange={(val) => {
              setXref({
                ...xref,
                NonSurvivorBusinessRecordSubTypeId: Number(val),
              })
            }}
            options={filteredConvertedSubTypes}
          />
          <SelectBox
            label="Non Survivor Filing Type"
            value={xref.NonSurvivorBusinessFilingTypeId}
            onChange={(val) => {
              setXref({
                ...xref,
                NonSurvivorBusinessFilingTypeId: Number(val),
              })
            }}
            options={filingTypeOptions}
          />
          {nonSurvivorError && !loadingNonSurvivorXref && (
            <div className="xref-warning">
              Warning: No Business Record to Filing Xref configured for selected Non Survivor types!
            </div>
          )}
          {loadingNonSurvivorXref && (
            <div className="conversion-spinner">
              <Spinner size="small" themeColor="dark-neutral" />
            </div>
          )}
        </div>
      </div>
      {/* <div className="conversion-center">
        <SelectBox
          label="Survivor Status after Approval"
          value={xref.PostConversionBusinessStatusTypeId}
          onChange={(val) => {
            setXref({
              ...xref,
              PostConversionBusinessStatusTypeId: Number(val),
            })
          }}
          options={businessStatusTypeOptions}
        />
        <CheckboxList
          modalMaxHeight
          checkListOnly
          label="Receipt Item Types"
          items={receiptItemTypes
            .filter((type) => type.ReceiptItemCategoryTypeId === 2)
            .map((type) => {
              return {
                label: type.Name,
                id: type.Id,
              }
            })}
          checkedList={receiptItemTypeIds || []}
          setActiveChanges={(newTypes) => {
            // console.log(newTypes)
            setReceiptItemTypeIds([...newTypes])
          }}
        />
        <CheckboxList
          modalMaxHeight
          checkListOnly
          label={'Generated Reports'}
          items={appReports
            .filter(
              (report) =>
                report.Category.includes('Business') ||
                report.Category.includes('Fiscal') ||
                report.Category.includes('Certifications')
            )
            .map((appReport) => ({ id: appReport.Id, label: appReport.Name }))
            .sort((a, b) => {
              return a.label > b.label ? 1 : -1
            })}
          checkedList={reportIds || []}
          setActiveChanges={(ids) => {
            // console.log(ids)
            setReportIds([...ids])
          }}
        />
      </div> */}
      <ContextBar elevation="standard" className="modal-context-bar">
        <ContextButton
          variant="danger"
          // disabled={!isDirty}
          leftIcon={
            <div className="checkmark-wrapper left">
              <Revert />
            </div>
          }
          onClick={revert}
        >
          Revert
        </ContextButton>
        <ContextButton
          variant="secondary"
          // disabled={!isDirty}
          onClick={() => {
            setXref({})
            // setReceiptItemTypeIds([])
            // setReportIds([])
            closeModal(false)
          }}
        >
          Close
        </ContextButton>
        <ContextButton
          variant="primary"
          // disabled={!isDirty}
          rightIcon={
            <div className="checkmark-wrapper right">
              <RightArrow />
            </div>
          }
          onClick={saveXref}
        >
          Save
        </ContextButton>
      </ContextBar>
    </div>
  )
}

export default MergerModal

// const defaultMergerXref = {
//   MergerConfigurationXrefId: 0,
//   BusinessFilingTypeId: 0,
//   SurvivorBusinessRecordTypeId: 0,
//   SurvivorBusinessRecordSubTypeId: 0,
//   NonSurvivorBusinessRecordTypeId: 0,
//   NonSurvivorBusinessRecordSubTypeId: 0,
//   NonSurvivorBusinessFilingTypeId: 0,
//   // PostMergerSurvivorBusinessStatusTypeId: 0,
//   // ReportIds: [],
//   // ReceiptItemTypeIds: [],
// }
